define(['legacy/modules/common/collections/enum'], (Enum) => ({
    accountTypes: Enum.of('accounttypes'),
    accountStatuses: Enum.of('accountstatuses'),
    columnPresetScopes: Enum.of('columnpresetscopes'),

    connectionTypes: Enum.of('connectiontypes'),

    keywordStatsIntervals: Enum.of('keywordstatsintervals'),

    projectStatuses: Enum.of('projectstatuses'),
    projectBudgetScopes: Enum.of('projectbudgetscopes'),

    orderPayTypes: Enum.of('orderpaytypes'),
    orderFormats: Enum.of('orderformats'),
    orderGenders: Enum.of('ordergenders'),
    orderExcludedCategories: Enum.of('orderexcludedcategories'),

    payerTypes: Enum.of('payertypes'),
    payerOpfs: Enum.of('payeropfs'),
    payerPaperBaseTypes: Enum.of('payerpaperbasetypes'),

    placementStatuses: Enum.of('placementstatuses'),
    placementFactStatuses: Enum.of('placementfactstatuses'),
    placementTaggingStatuses: Enum.of('placementtaggingstatuses'),
    placementTypes: Enum.of('placementtypes'),
    placementStrategyTypes: Enum.of('placementstrategytypes'),

    planFactTypes: Enum.of('planfacttypes'),
    profileGoalType: Enum.of('profilegoaltype'),

    reportStatuses: Enum.of('reportstatuses'),
    reportEntityTypes: Enum.of('reportentitytypes'),
    reportFormats: Enum.of('reportformats'),
    reportNetworks: Enum.of('reportnetworks'),
    reportPeriodTypes: Enum.of('reportperiodtypes'),
    reportTypes: Enum.of('reporttypes'),
    reportScheduleRepetitions: Enum.of('reportschedulerepetitions'),
    customReportBorders: Enum.of('customborders'),
    customReportFieldTotalCalcMethods: Enum.of('customreportfieldtotalcalcmethods'),

    statsGrouping: Enum.of('statsgrouping'),
    statsFiltering: Enum.of('statsfiltering'),
    statsDateGrouping: Enum.of('statsdategrouping'),

    userNotifications: Enum.of('usernotifications'),
    userStates: Enum.of('userstates'),

    billAccountGrouping: Enum.of('billaccountgrouping'),
    yandexMarketFieldsTypes: Enum.of('yandexmarketfieldstypes'),

    syncSourceIntervals: Enum.of('syncsourceintervals'),
    syncSourceFieldTypes: Enum.of('syncsourcefieldtypes'),

    entityLogActions: Enum.of('entitylogactions'),
    historyEntityTypes: Enum.of('historyentitytypes'),

    segmentTypes: Enum.of('segmenttypes'),
    segmentGroupsFiltering: Enum.of('segmentgroupsfiltering'),
    segmentTypesFiltering: Enum.of('segmenttypesfiltering'),
    segmentAudiences: Enum.of('segmentaudiences'),

    roreOrderStatuses: Enum.of('roreorderstatuses'),
    roreOrderCreativesStatuses: Enum.of('roreordercreativesstatuses'),
    roreOrderBillingStatuses: Enum.of('roreorderbillingstatuses'),
    roreOrderCounterStatuses: Enum.of('roreordercounterstatuses'),
    roreOrderProject1cStatuses: Enum.of('roreorderproject1cstatuses'),
    roreOrderTradingStatuses: Enum.of('roreordertradingstatuses'),
    roreOrderClientStatuses: Enum.of('roreorderclientstatuses'),

    roreOrderFreqUnits: Enum.of('roreorderfrequnits'),
    roreOrderBudgetSplits: Enum.of('roreorderbudgetsplits'),
    roreOrderBuyingModels: Enum.of('roreorderbuyingmodels'),
    roreTrackerBuyingModels: Enum.of('roretrackerbuyingmodels'),
    roreOrderPlanningType: Enum.of('roreorderplanningtype'),
    roreHistoryEntityTypes: Enum.of('rorehistoryentitytypes'),
    roreExternalTechCostType: Enum.of('roreexternaltechcosttype'),
    roreTechCostType: Enum.of('roretechcosttype'),
    roreRecalculatePeriodsType: Enum.of('rorerecalculateperiodstype'),

    customMetricTypes: Enum.of('custommetricstypes'),
    bidmanagerMonitoringMetrics: Enum.of('bidmanagermonitoringmetrics'),

    attributionType: Enum.of('yandexmetrka/attributiontype')
}));
